import { useContext } from "react";

import AuthContext from "../context/AuthContext";

const useAuthContext = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw Error("Must be called inside AuthContext.Provider");
  }

  return context;
};

export default useAuthContext;
